module.exports = __webpack_public_path__ + "static/janet-2204e01ba023e6113635bd4adb80dd29.jpg";